function filterData(data) {
  const filteredObj = {};
  filteredObj.temp = data.observation.metric.temp || '';
  filteredObj.iconCode = data.observation.icon_code || '';
  filteredObj.skyCover = data.observation.phrase_32char || '';
  filteredObj.isDay = data.observation.day_ind === 'D';
  return filteredObj;
}

export default { filterData };
